// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Z3iUi","border":"styles_border__yd6wT"};